<template>
    <section class="container container-medium">
        <div class="steps-wrapper">
            <div class="strike-through"></div>
            <div class="steps">
                <div class="step" v-for="step in steps" :key="step.id">
                    <div class="step-bullet" :class="{'active': (step.stepNumber <= currentPage), 'not-active': (step.stepNumber > currentPage)}">
                        <template v-if="step.route">
                            <router-link :to="{name: step.route}">
                                <div v-if="currentPage > step.stepNumber" class="icon v-icon"></div>
                                <div v-else>{{ step.stepNumber }}</div>
                            </router-link>
                        </template>
                        <template v-else="step.route">
                            <div v-if="currentPage > step.stepNumber" class="icon v-icon"></div>
                            <div v-else>{{ step.stepNumber }}</div>
                        </template>
                    </div>
                    <div class="step-name">
                        <template v-if="step.route">
                            <router-link :to="{name: step.route}">
                                {{step.name}}
                            </router-link>
                        </template>
                        <template v-else="step.route">
                            {{step.name}}
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: 'Steps',
        components: {
        },
        props: ['currentPage'],
        computed: {
        },
        data: function() {
            return {
                steps: [
                    {
                        id: 1,
                        name: this.$t('vehicle_type'),
                        stepNumber: 1,
                        completed: false
                    },
                    {
                        id: 2,
                        name: this.$t('period'),
                        stepNumber: 2,
                        completed: true
                    },
                    {
                        id: 3,
                        name: this.$t('summary'),
                        stepNumber: 3,
                        completed: true,
                        route: 'cart'
                    },
                    {
                        id: 4,
                        name: this.$t('billing'),
                        stepNumber: 4,
                        completed: true,
                        route: 'billing'
                    },
                    {
                        id: 5,
                        name: this.$t('payment'),
                        stepNumber: 5,
                        completed: true,
                        route: 'payment-method'
                    },
                ]
            }
        },
        mounted() {
        },
        methods: {
        }
    }
</script>

<style scoped lang="scss">
    @import '../../assets/scss/_variables';

    .steps-wrapper{
        position: relative;
        z-index: 1;
        margin-top: 30px;

        .strike-through {
            background: $black;
            width: calc(100% - 1px);
            height: 1px;
            top: calc(50% - 1px);
            position: absolute;
            z-index: 1;
        }

        .steps {
            position:relative;
            z-index: 2;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .step {

                &:not(:first-child) {
                    padding-left: 10.5px;
                    background: $bg-light;
                }

                &:not(:last-child) {
                    padding-right: 10.5px;
                    background: $bg-light;
                }

                @media only screen and (min-width: 768px) {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;

                }

                .step-bullet {
                    width: 30px;
                    height: 30px;
                    border-radius: 50%;
                    background: $black;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    color: white;
                    font-weight: bold;

                    a {
                        text-decoration: none;
                    }

                    &.not-active {
                        background: $step-grey;
                    }

                    &.active {
                        background: $black;

                    }

                    div {
                        color: white;
                    }
                }

                .step-name {
                    font-weight: bold;
                    color: $black;
                    margin-left: 9px;

                    a {
                        color: $black;
                        text-decoration: none;
                    }

                    @media only screen and (max-width: 768px) {
                        display: none;
                    }
                }
            }
        }

    }
</style>
